import React, { useState, useEffect } from "react";
import { useImpersonation } from "../context/ImpersonationContext";
import { MdAdminPanelSettings, MdArrowBack } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import "./ImpersonationBanner.css";

const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedVendorName, exitImpersonation } = useImpersonation();
  const [exiting, setExiting] = useState(false);

  // Reset loading state whenever a new impersonation session starts
  useEffect(() => {
    if (isImpersonating) setExiting(false);
  }, [isImpersonating]);

  if (!isImpersonating) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exitImpersonation();
    } catch (_) {
      setExiting(false);
    }
  };

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner__inner">
        <div className="impersonation-banner__left">
          <span className="impersonation-banner__icon">
            <MdAdminPanelSettings size={18} />
          </span>
          <span className="impersonation-banner__badge">Admin View</span>
          <span className="impersonation-banner__divider" />
          <FaEye size={13} className="impersonation-banner__eye" />
          <span className="impersonation-banner__label">
            Viewing as&nbsp;
            <strong className="impersonation-banner__name">
              {impersonatedVendorName || "Vendor"}
            </strong>
          </span>
          <span className="impersonation-banner__note">
            — All actions performed here are on behalf of this vendor account
          </span>
        </div>

        <button
          className="impersonation-banner__back-btn"
          onClick={handleExit}
          disabled={exiting}
        >
          <MdArrowBack size={15} />
          {exiting ? "Returning…" : "Return to Admin Dashboard"}
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
